import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import type { ServiceRequestView } from '../../lib/service-request-views';
import { Button } from '../ui/button';
import { PageFrame } from './page-chrome';
import { PageTitle } from './page-states';
import ServiceRequestNav from './ServiceRequestNav';

/**
 * One frame for every Service Request view: the same title, the same view strip,
 * and the same page chrome as the rest of Pulse.
 */
export default function ServiceRequestShell({
  active,
  subtitle,
  children,
}: {
  active: ServiceRequestView;
  /** Optional context under the title, e.g. "as of 21 Sep 2026, 10:00". */
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <PageFrame>
      <div className="flex flex-1 flex-col gap-4">
        <PageTitle
          title="Service requests"
          description={subtitle}
          action={
            <Button asChild>
              <Link to="/service-requests/new">
                <Plus className="h-4 w-4" aria-hidden />
                New request
              </Link>
            </Button>
          }
        />
        <ServiceRequestNav active={active} />
        {children}
      </div>
    </PageFrame>
  );
}
